import type { ContactFormData } from '@workspace/interfaces/contact-form.types';
import {
  stateOptions,
  areaOfWorkOptions,
  hearAboutOptions,
  enquiryTypeOptions,
} from '@workspace/constants/contact-form.constant';

export const getDropdownOptions = (name: keyof ContactFormData) => {
  switch (name) {
    case 'state':
      return stateOptions;
    case 'area_of_work':
      return areaOfWorkOptions;
    case 'where_did_you_hear_about_porta_':
      return hearAboutOptions;
    case 'enquiry_type___dropdown':
      return enquiryTypeOptions;
    default:
      return [];
  }
};
